import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Check, ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Section, Overline, usePageTitle } from "@/components/site/ui-bits";

const Icon = ({ name, ...p }) => {
  const C = Icons[name] || Icons.Sparkles;
  return <C {...p} />;
};

export default function Services() {
  usePageTitle("Nos services");
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }
  }, [hash]);

  return (
    <div data-testid="services-page">
      <section className="bg-gradient-to-b from-sky-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24 text-center">
          <Overline>Nos services</Overline>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">Des prestations complètes</h1>
          <p className="mt-5 text-slate-600 max-w-2xl mx-auto">Découvrez l'ensemble de nos domaines d'intervention pour particuliers et professionnels.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 space-y-20">
        {SERVICES.map((s, i) => (
          <div key={s.slug} id={s.slug} data-testid={`service-detail-${s.slug}`} className={`scroll-mt-28 grid lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}>
            <div>
              <img src={s.image} alt={s.title} className="rounded-3xl shadow-xl w-full object-cover aspect-[4/3]" />
            </div>
            <div>
              <div className="w-12 h-12 rounded-xl bg-sky-50 flex items-center justify-center text-[#0ea5e9]"><Icon name={s.icon} size={22} /></div>
              <h2 className="mt-5 text-3xl font-bold text-slate-900">{s.title}</h2>
              <p className="mt-3 text-slate-600">{s.short}</p>
              <ul className="mt-6 space-y-3">
                {s.details.map((d) => (
                  <li key={d} className="flex gap-3 text-sm text-slate-700">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-sky-100 text-[#0ea5e9] flex items-center justify-center flex-shrink-0"><Check size={13} /></span>
                    {d}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="mt-7 inline-flex items-center gap-2 text-[#0ea5e9] font-semibold hover:gap-3 transition-all">Demander un devis <ArrowRight size={16} /></Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
